<template>
  <div class="yearluck-base">
    <div class="contents-wrap">
      <form id="send-form" :action="submitPath" method="POST">
        <template v-for="(item, key) in receiveFormData">
          <input
            v-if="key !== 'target_nickname' && key !== 'target_birthday'"
            type="hidden"
            :key="key"
            :name="key"
            :value="item"
          />
        </template>
        <input type="hidden" name="target_nickname" :value="frmTargetNickname" />
        <input type="hidden" name="target_birthday" :value="frmTargetBirthday" />
        <input type="hidden" name="items_id" :value="sendItemId"/>
      </form>

      <user-prof-str
        :user-name="receiveFormData['nickname']"
        :user-birthday="[receiveFormData['year'],receiveFormData['month'], receiveFormData['day']].join('-')"
      ></user-prof-str>

      <div class="summery-list">
        <template v-for="(item, index) in summaryList">
          <article-card
            :key="index"
            :idx="index"
            :tgt-item="item"
            :is-large="index === 0"
            :group="'summary'"
            :tgt-birthday="tgtBirthday"
            :campaign-stat="campaignStat"
            @detailBtnClick="onDetailBtnClick"
          ></article-card>
        </template>
      </div>
    </div>

    <div class="set-item-list" id="setmenu">
      <h4><img src="/static/img/yearluck/y2020/titlelabel/setmenu.svg"></h4>
      <template v-for="(item, index) in setItemList">
        <article-card
          :key="index"
          :idx="index"
          :tgt-item="item"
          :group="'setItem'"
          @detailBtnClick="onDetailBtnClick"
        ></article-card>
      </template>
    </div>

    <dialog-base :trigger="isDetailDialogOpen" @dialogClose="onDialogClose">
      <purchase-dialog
        :item-data="targetDetailData"
        :target-idx="targetIdx"
        :text-price="textPrice"
        :text-audio-price="textAudioPrice"
        :text-item-id="textItemId"
        :target-nickname-receive="receiveFormData.target_nickname"
        :target-birthday-receive="receiveFormData.target_birthday"
        :has-setmenu-recommend="hasSetMenuRecommend"
        :is-set-purchase="isSetPurchase"
        :has-affinity="hasAffinity"
        :is-summary="true"
        @submit="onPurchaseSubmit"
        @closeAndGoSet="onCloseAndGoSet"
      ></purchase-dialog>
    </dialog-base>
  </div>
</template>

<script>
import ArticleCard from '@/utvStore/components/YearLuck/y2020/partials/articleCard.vue'
import DialogBase from "./partials/dialogBase";
import PurchaseDialog from "./partials/purchaseDialog";
import itemcomp from './constants/items'
import UserProfStr from '@/utvStore/components/YearLuck/y2020/partials/userProfStr'

export default {
  name: "Yearluck2020Summary",
  components: {PurchaseDialog, DialogBase, ArticleCard, UserProfStr },
  data() {
    return {
      lock: false,
      campaignStat: '', //キャンペーン時などの詳細ボタンの挙動を変更する文字列を指定（分岐処理はarticleCard.vue）
      isDetailDialogOpen: false,
      targetDetailData: {},
      sendItemId: -1,
      targetIdx: -1,
      textPrice: 99,
      textItemId: -1,
      submitPath: '',
      textAudioPrice: 150,
      hasSetMenuRecommend: false,
      hasAffinity: false,
      isSetPurchase: false,
      frmTargetNickname: '',
      frmTargetBirthday: '',
    }
  },
  props: {
    receiveFormData: {
      type: Object,
      default() {
        return {}
      }
    },
    summaryData: {
      type: Array,
      default() {
        return []
      }
    },
    setItemData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    userProfStr() {
      const y = this.receiveFormData['year']
      const m = this.receiveFormData['month']
      const d = this.receiveFormData['day']
      const nickname = this.receiveFormData['nickname']
      return `${ y }年${ m }月${ d }日生まれの${ nickname }さん`
    },
    summaryList() {
      return this.summaryData
    },
    setItemList() {
      return this.setItemData
    },
    tgtBirthday() {
      return this.receiveFormData['target_birthday'] || ''
    }
  },
  methods: {
    onDialogClose() {
      this.isDetailDialogOpen = false
      this.purchaseDialogReset = false
      this.lock = false
    },
    onCloseAndGoSet() {
      this.isDetailDialogOpen = false
      this.purchaseDialogReset = false
      this.lock = false
      setTimeout(()=> {
        const element = document.getElementById('setmenu')
        const rect = element.getBoundingClientRect()
        const position = rect.top
        scrollTo(0, position)
      },300)
    },

    onDetailBtnClick(idx, tgt){
      if( this.isCampaign === '202002' && tgt !== 'setItem') {
        const targetElement = document.querySelector('#setmenu');
        const rectTop = targetElement.getBoundingClientRect().top
        const offsetTop = window.pageYOffset
        const buffer = 0
        const top = rectTop + offsetTop - buffer
        window.scrollTo({
          top,
          behavior: "smooth"
        });
      } else {
        if (!this.lock) {
          // console.log('詳細ボタンクリック', idx, tgt, this.targetDetailData)
          this.lock = true
          this.targetIdx = idx
          switch (tgt) {
            case 'summary':
              // console.log('単品アイテムをセットするよ')
              this.targetDetailData = this.summaryList[idx]
              this.isSetPurchase = false
              this.hasAffinity = this.summaryList[idx].textItemId === 295
                || this.summaryList[idx].textAudioItemId === 296
              break
            case 'setItem':
              // console.log('セットアイテムをセットするよ')
              this.targetDetailData = this.setItemList[idx]
              this.isSetPurchase = true
              this.hasAffinity = this.targetDetailData.textItemId === 299
                || this.targetDetailData.textAudioItemId === 300
                || this.targetDetailData.textItemId === 303
                || this.targetDetailData.textAudioItemId === 304
              break
            case 'affinity':
              // console.log('相性単品アイテムをセットするよ')
              this.targetDetailData = this.summaryList[idx]
              this.isSetPurchase = false
              this.hasAffinity = true
              break
          }
          this.textItemId = this.targetDetailData.textItemId
          this.textPrice = parseInt(this.targetDetailData.textItemPrice)
          this.textAudioPrice = parseInt(this.targetDetailData.textAudioItemPrice)

          this.$nextTick(() => {
            this.isDetailDialogOpen = true
          })
        }
      }
    },
    onPurchaseSubmit(itemtype, idx, isSetPurchase, additionalInfo) {
      // console.log('summary submit: %s -- idx:%s', itemtype, idx)
      //現状ここで実際のテキストかオーディオか判定できない
      let itemsId
      switch ( itemtype ) {
        case 't':
          // console.log('表示上はテキストを選択')
          if(!isSetPurchase) {
            itemsId = this.summaryData[idx]['textItemId']
          } else{
            itemsId = this.setItemData[idx]['textItemId']
          }
          break
        case 'ta':
          if(!isSetPurchase) {
            // console.log('表示上はテキスト＆オーディオを選択')
            itemsId = this.summaryData[idx]['textAudioItemId']
          } else {
            itemsId = this.setItemData[idx]['textAudioItemId']
          }
          break
      }
      this.sendItemId = itemsId
      this.submitPath = `/special/${ itemsId }/complete`
      // console.log('itemsId: %s action path: %s', itemsId, this.submitPath)
      const frm = document.getElementById('send-form')
      if(additionalInfo != null && additionalInfo.hasAffinity){
        //データの整合性チェックする？
        // console.log('追加情報：%O', additionalInfo)
        this.frmTargetNickname = additionalInfo.tgtNickname
        this.frmTargetBirthday = additionalInfo.tgtBirthday
      }
      frm.addEventListener('submit', (e) => {})
      this.$nextTick(()=>{
        // console.log('----------------------')
        // console.log('Formオブジェクト: %O', frm)
        // console.log('対象アイテム: %O', this.summaryList[idx])
        // console.log('action path: %s', this.submitPath)
        frm.submit()
      })
      this.isDetailDialogOpen = false
    }
  }
}</script>

<style scoped lang="scss">
@import '../../../../../sass/variables/index';
.yearluck-base {
  padding: 8px 0 0;
  .contents-wrap {
    padding: 0 16px 8px;
    @include mq('w320') {
      padding: 0 25px 8px;
    }
  }
  .set-item-list {
    background: #fbfaf7;
    padding: 14px 16px 25px;
    @include mq('w320') {
      padding: 14px 25px 25px;
    }
    h4 {
      width: 100%;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2020/yearluck2020Summary.vue